import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LayoutsModule } from './layouts/layouts.module';
import { PagesModule } from './pages/pages.module';

// Auth
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorInterceptor } from './core/helpers/error.interceptor';

// Language
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ViewPageComponent } from './_commonComponents/view-page/view-page.component';
// import { RecordPaymentComponent } from './_commonComponents/record-payment/record-payment.component';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { environment } from 'src/environments/environment';
import { ViewCatalogueComponent } from './_commonComponents/view-catalogue/view-catalogue.component';
import { ViewProductComponent } from './_commonComponents/view-product/view-product.component';
import { SwiperConfigInterface, SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { JwtInterceptor } from './core/helpers/auth.interceptor';
import { RefreshInterceptor } from './core/helpers/refresh.interceptor';
import { AuthGuard } from './core/guards/auth.guard';
import { ExpiryInterceptor } from './core/helpers/expiry.interceptory';
// import { SupplierComponent } from './pages/purchases/_components/supplier/supplier.component';
// import { AddSupplierComponent } from './pages/purchases/_components/add-supplier/add-supplier.component';
// import { ViewSupplierComponent } from './pages/purchases/_components/view-supplier/view-supplier.component';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto',
};

// const config: SocketIoConfig = {
//   url: environment.socketUrl, // socket server url;
//   options: {
//     transports: ['websocket']
//   }
// }

@NgModule({
  declarations: [
    AppComponent,
    ViewPageComponent,
    ViewCatalogueComponent,
    // RecordPaymentComponent,
    // SupplierComponent,
    // AddSupplierComponent,
    // ViewSupplierComponent,
  ],
  imports: [
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    BrowserAnimationsModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    LayoutsModule,
    PagesModule,
    FormsModule,
    ReactiveFormsModule,
    // SocketIoModule.forRoot(config),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ExpiryInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshInterceptor,
      multi: true,
    },
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
